import { Box, Text } from '@chakra-ui/react';
import { AUDIO_TRACK_CONTAINER_ID, AUDIO_TRACK_ID } from './constants';
import { audioPlayerTrackSx } from './styles';
import { MidiDensityCanvas } from './MidiDensityCanvas';

interface AudioPlayerTrackProps {
  duration: number;
  isLoadingAudio: boolean;
  src?: string;
  isError?: boolean;
  playbackEngineType?: string;
  currentTime?: number;
  onSeek?: (progress: number) => void;
  noteDensity?: number[];
}

export const AudioPlayerTrack = ({
  duration,
  isLoadingAudio,
  src,
  isError,
  playbackEngineType,
  currentTime = 0,
  onSeek,
  noteDensity,
}: AudioPlayerTrackProps) => {
  const styles = audioPlayerTrackSx({
    isLoading: isLoadingAudio || isError || !duration,
  });
  const progress = duration > 0 ? currentTime / duration : 0;

  const isMidi = playbackEngineType === 'midi';

  return (
    <>
      {isMidi && (
        <Box
          sx={{
            ...styles.audioTrack,
            gridArea: 'unset',
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            px: 0,
          }}
        >
          <MidiDensityCanvas
            density={noteDensity || []}
            progress={progress}
            onSeek={onSeek}
          />
          {isError && (
            <Text sx={styles.error} data-testid="audio-error">
              There was a problem loading file
            </Text>
          )}
        </Box>
      )}
      <Box
        id={AUDIO_TRACK_CONTAINER_ID}
        sx={{
          ...styles.audioTrack,
          ...(isMidi && { display: 'none' }),
        }}
      >
        <audio id={AUDIO_TRACK_ID} src={src}>
          <track src="" kind="captions" label="song" />
        </audio>
        {!isMidi && isError && (
          <Text sx={styles.error} data-testid="audio-error">
            There was a problem loading file
          </Text>
        )}
      </Box>
    </>
  );
};
